// import CreateHPoolChooseTokens from '../components/Pages/CreateHPool/CreateHPoolChooseTokens/CreateHPoolChooseTokens';
// import CreateHPoolCreateTicketsForm from '../components/Pages/CreateHPool/CreateHPoolCreateTicketsForm/CreateHPoolCreateTicketsForm';
// import CreateHPoolPoolInfoForm from '../components/Pages/CreateHPool/CreateHPoolPoolInfoForm/CreateHPoolPoolInfoForm';
// import CreateHPoolReview from '../components/Pages/CreateHPool/CreateHPoolReview/CreateHPoolReview';
// import CreateHPoolDepositFundsForm from '../components/Pages/CreateHPool/CreateHPoolDepositFundsForm/CreateHPoolDepositFundsForm';

import { SET_HAS_COMPLETED_SAFTS_STEP } from '../redux/actionTypes/createHPoolActionTypes';

export const POOL_ALLOCATION_PER_TICKET = '';
export const MIN_POOL_ALLOCATION = '';
export const MAX_POOL_ALLOCATION = '';

export const CREATE_HPOOL_ACTIONS = {
  createHPool: 'createHPool',
  assignNFT: 'assignNFT',
  updateHPool: 'updateHPool',
  submitHPool: 'submitHPool',
  addFunds: 'addFunds',
  choosePoolType: 'choosePoolType',
  nextStep: 'nextStep',
  setSaftStepHasBeenCompleted: SET_HAS_COMPLETED_SAFTS_STEP,
};

export const CREATE_HPOOL_REQUIRED_TOKENS = {
  eth: {
    network: 'ethereum',
    symbol: 'ETH',
    address: null,
    verified_token_lists: ['1inch'],
    additionalText: 'pools.hpool_must_contain_at_least',
    name: 'Ethereum',
    percentage: 80,
    deleteDisabled: true,
    color: '#fff',
  },
  hord: {
    network: 'ethereum',
    symbol: 'HORD',
    verified_token_lists: ['1inch'],
    additionalText: 'pools.hpool_must_contain_at_least',
    name: 'HORD',
    percentage: 20,
    color: '#8D6752',
  },
};

export const HPOOL_DEFAULT_TOKEN = {
  tether: {
    network: 'binance',
    token_id: 1300, // hardcoded token_id
    symbol: 'USDT',
    address: '0xfd5840cd36d94d7229439859c0112a4185bc0255',
    verified_token_lists: ['1inch'],
    image: 'https://cryptologos.cc/logos/tether-usdt-logo.png',
    name: 'Tether',
    percentage: 0,
    color: '#1CA077',
    deleteDisabled: true,
    showToken: true,
  },
};

export const mockWhitelistedWallets = ['0xeea624f2aa26d5aa1dec8d96f8e84743a7dfff6a'];

export const CREATE_HPOOL_STEPS = [
  {
    id: 1,
    component: () => import('../components/Pages/CreateHPool/ChoosePoolType/ChoosePoolType'),
    path: 'choose-pool-type',
    title: 'pools.desc_0_title',
    description: () => 'pools.desc_0',
    action: CREATE_HPOOL_ACTIONS.choosePoolType,
    completedOn: (createHPool) => typeof createHPool?.isVpool === 'boolean' || Number.isInteger(createHPool?.hpool?.id),
  },
  {
    id: 2,
    component: () => import('../components/Pages/CreateHPool/CreateHPoolChooseTokens/CreateHPoolChooseTokens'),
    path: 'choose-tokens',
    title: 'pools.desc_1_title',
    description: (isVpool) => (isVpool ? 'vpool.desc_1' : 'pools.desc_1'),
    action: CREATE_HPOOL_ACTIONS.createHPool,
    completedOn: (createHPool) => createHPool?.hpool?.assets,
    cantEditAfter: true,
  },
  {
    id: 3,
    component: () =>
      import('../components/Pages/CreateHPool/CreateHPoolCreateTicketsForm/CreateHPoolCreateTicketsForm'),
    path: 'create-tickets',
    title: 'pools.desc_2_title',
    description: (isVpool) => (isVpool ? 'vpool.desc_2' : 'pools.desc_2'),
    action: CREATE_HPOOL_ACTIONS.assignNFT,
    completedOn: (createHPool) =>
      createHPool?.unattachedNFT?.image_s3 || createHPool?.hpool.nftImage || createHPool?.hpool.hpool_nft_image_url,
  },
  {
    id: 4,
    component: () => import('../components/Pages/CreateHPool/CreateHPoolPoolInfoForm/CreateHPoolPoolInfoForm'),
    path: 'pool-info',
    title: 'pools.desc_3_title',
    description: (isVpool) => (isVpool ? 'vpool.desc_3' : 'pools.desc_3'),
    action: CREATE_HPOOL_ACTIONS.updateHPool,
    completedOn: (createHPool) => createHPool?.hpool?.name,
  },
  {
    id: 5,
    component: () => import('../components/Pages/CreateHPool/CreateHPoolSignTransaction/CreateHPoolSignTradeOrders'),
    path: 'sign-trade-orders',
    title: 'pools.desc_5_title',
    description: () => 'hpool.desc_5',
    action: CREATE_HPOOL_ACTIONS.nextStep,
    completedOn: (createHPool) => {
      const isPoolCreated = !!createHPool?.hpool?.name;
      const hasOrders = createHPool.tradeOrders?.length;
      const allOrdersAreSigned = createHPool.tradeOrders?.every?.((tradeOrder) => tradeOrder.is_signed);
      const gotNoOrdersToSign = !createHPool.tradeOrders?.length;
      if (!isPoolCreated) return false;
      return (hasOrders && allOrdersAreSigned) || gotNoOrdersToSign;
    },
    cantEditAfter: true,
  },
  {
    id: 6,
    component: () => import('../components/Pages/CreateHPool/CreateHPoolProjectsTable/CreateHPoolProjectsTable'),
    path: 'review',
    title: 'pools.desc_4_title',
    description: (isVpool) => (isVpool ? 'pool.vpool_desc_4' : 'pools.desc_4'),
    action: CREATE_HPOOL_ACTIONS.setSaftStepHasBeenCompleted,
    completedOn: (createHPool) => createHPool.poolSafts?.hasCompletedSaftStep,
    allowBackToStep: true,
  },
  {
    id: 7,
    component: () => import('../components/Pages/CreateHPool/CreateHPoolDepositFundsForm/CreateHPoolDepositFundsForm'),
    path: 'deposit-funds',
    title: 'pools.desc_6_title',
    description: (isVpool) => (isVpool ? 'vpool.desc_6' : 'pools.desc_6'),
    action: CREATE_HPOOL_ACTIONS.addFunds,
    completedOn: (createHPool) => Number.isInteger(createHPool.hpool.web3_hpool_id),
    cantEditAfter: true,
  },
];

export const stakeAndReserveTicketsAbi = [
  {
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256',
  },
  {
    internalType: 'uint256',
    name: 'numberOfTickets',
    type: 'uint256',
  },
];

export const subscribtionAbi = [
  {
    internalType: 'uint256',
    name: 'poolId',
    type: 'uint256',
  },
];

export const withdrawSubscribtionFuncSign = {
  name: 'withdrawDeposit',
  type: 'function',
  stateMutability: 'nonpayable',
  inputs: [{ internalType: 'uint256', name: 'poolId', type: 'uint256' }],
  outputs: [],
};

export const championWithdraw = {
  inputs: [
    {
      internalType: 'uint256',
      name: 'poolId',
      type: 'uint256',
    },
  ],
  name: 'withdrawDepositToChampion',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function',
};

export const privateSubscribtionFuncSign = {
  inputs: [
    {
      internalType: 'uint256',
      name: 'poolId',
      type: 'uint256',
    },
  ],
  name: 'privateSubscribeForHPool',
  outputs: [],
  stateMutability: 'payable',
  type: 'function',
};
export const publicSubscribtionFuncSign = {
  inputs: [
    {
      internalType: 'uint256',
      name: 'poolId',
      type: 'uint256',
    },
  ],
  name: 'publicSubscribeForHPool',
  outputs: [],
  stateMutability: 'payable',
  type: 'function',
};

export const IndividualLiquidationAbi = [
  {
    indexed: false,
    internalType: 'address',
    name: 'paidByUser',
    type: 'address',
  },
  {
    indexed: false,
    internalType: 'uint256',
    name: 'totalProfitUSD',
    type: 'uint256',
  },
  {
    indexed: false,
    internalType: 'uint256',
    name: 'totalUSDAtLaunch',
    type: 'uint256',
  },
  {
    indexed: false,
    internalType: 'uint256',
    name: 'ethWithdrawn',
    type: 'uint256',
  },
  {
    indexed: false,
    internalType: 'uint256',
    name: 'hordWithdrawn',
    type: 'uint256',
  },
  {
    indexed: false,
    internalType: 'uint256',
    name: 'totalHPoolTokensInitialWorthUsd',
    type: 'uint256',
  },
  {
    indexed: false,
    internalType: 'uint256',
    name: 'totalHPoolTokensInitialWorthEth',
    type: 'uint256',
  },
];

export const FeesTakenAbi = [
  { indexed: false, internalType: 'uint256', name: 'championFee', type: 'uint256' },
  { indexed: false, internalType: 'uint256', name: 'protocolSuccessFee', type: 'uint256' },
  { indexed: false, internalType: 'uint256', name: 'redemptionFee', type: 'uint256' },
];

export const initMarketMethodSign = {
  inputs: [
    {
      internalType: 'address',
      name: 'dstToken',
      type: 'address',
    },
    {
      internalType: 'uint256',
      name: 'ratio',
      type: 'uint256',
    },
    {
      internalType: 'uint256',
      name: 'amountSrc',
      type: 'uint256',
    },
    {
      internalType: 'uint256',
      name: 'minAmountOut',
      type: 'uint256',
    },
    {
      internalType: 'uint256',
      name: 'poolNonce',
      type: 'uint256',
    },
    {
      internalType: 'bytes32',
      name: 'sigR',
      type: 'bytes32',
    },
    {
      internalType: 'bytes32',
      name: 'sigS',
      type: 'bytes32',
    },
    {
      internalType: 'uint8',
      name: 'sigV',
      type: 'uint8',
    },
  ],
  name: 'verifyAndExecuteBuyOrderRatio',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function',
};

export const marketOrderMethodSign = {
  inputs: [
    {
      internalType: 'address',
      name: 'srcToken',
      type: 'address',
    },
    {
      internalType: 'address',
      name: 'dstToken',
      type: 'address',
    },
    {
      internalType: 'uint256',
      name: 'ratio',
      type: 'uint256',
    },
    {
      internalType: 'uint256',
      name: 'amountSrc',
      type: 'uint256',
    },
    {
      internalType: 'uint256',
      name: 'minAmountOut',
      type: 'uint256',
    },
    {
      internalType: 'uint256',
      name: 'poolNonce',
      type: 'uint256',
    },
    {
      internalType: 'bytes32',
      name: 'sigR',
      type: 'bytes32',
    },
    {
      internalType: 'bytes32',
      name: 'sigS',
      type: 'bytes32',
    },
    {
      internalType: 'uint8',
      name: 'sigV',
      type: 'uint8',
    },
  ],
  name: 'verifyAndExecuteTradeOrderExactAmount',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function',
};

export const initMarketBuyAbi = [
  {
    internalType: 'address',
    name: 'dstToken',
    type: 'address',
  },
  {
    internalType: 'uint256',
    name: 'ratio',
    type: 'uint256',
  },
  {
    internalType: 'uint256',
    name: 'amountSrc',
    type: 'uint256',
  },
  {
    internalType: 'uint256',
    name: 'minAmountOut',
    type: 'uint256',
  },
  {
    internalType: 'uint256',
    name: 'poolNonce',
    type: 'uint256',
  },
  {
    internalType: 'bytes32',
    name: 'sigR',
    type: 'bytes32',
  },
  {
    internalType: 'bytes32',
    name: 'sigS',
    type: 'bytes32',
  },
  {
    internalType: 'uint8',
    name: 'sigV',
    type: 'uint8',
  },
];
window.initMarketMethodSign = initMarketMethodSign;
window.initMarketBuyAbi = initMarketBuyAbi;
window.marketOrderMethodSign = marketOrderMethodSign;
